import React from 'react'
import { connect } from 'react-redux'

import { receiptSelectors } from '../../core/receipt'
import { receiptActions } from '../../core/receipt'

class TaxCost extends React.Component {
  _onChange (taxCost) {
    if (!taxCost || isNaN(taxCost)) {
      taxCost = 0
    }

    taxCost = Number(taxCost)

    return this.props.onChange(taxCost)
  }

  render () {
    return (
      <p>
        <span>Tax: $ </span>
        <input type="number" placeholder="6.21" onChange={(node) => this._onChange(node.target.value)} />
      </p>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    taxCost: receiptSelectors.getTaxCost(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (taxCost) => dispatch(receiptActions.changeTaxCost(taxCost))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxCost)



/** WEBPACK FOOTER **
 ** ./src/views/containers/TaxCost.js
 **/